import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTooltip } from './useTooltip';
import { zIndexValue as zIndexPosition } from '../helpers/position';
import { getPx } from '../helpers/common';
const OuterWrapper = styled.div`
  position: absolute;
  ${({
  $offset,
  $enterOffset
}) => `
    top: -${getPx($offset + $enterOffset)};
    bottom: -${getPx($offset + $enterOffset)};
    left: -${getPx($offset + $enterOffset)};
    right: -${getPx($offset + $enterOffset)};
  `}
`;
const Wrapper = styled.div`
  position: relative;
  box-sizing: content-box;
  ${({
  flex
}) => flex && `
    display: inline-flex;
    justify-content: center;
    align-items: center;
  `}
`;
export const Tooltip = ({
  open,
  defaultOpen = false,
  inverse = false,
  blurred = false,
  withOverflowHidden = false,
  animate = true,
  parentQuerySelector,
  parentElement,
  offset = 8,
  enterOffset = 8,
  multiline = false,
  trigger = 'hover',
  position = 'top',
  onClick,
  onOpen,
  onClose,
  onToggle,
  onOpened,
  onClosed,
  onToggled,
  content,
  renderContent,
  zIndex = zIndexPosition('tooltip'),
  noPadding = false,
  withMargin = false,
  wrapperStyle,
  customWrapper,
  width,
  height,
  disabled,
  size = 'small',
  appearType = 'slide',
  flex = false,
  children,
  closeOnScroll = false,
  closeOnResize = false,
  closeOnOutsideClick = true,
  noFlip = true,
  closeDelay,
  excludeRef,
  portalWrapperStyle,
  hideTooltipOnFullText = false,
  ...props
}) => {
  const [truncated, setTruncated] = useState(true);
  const {
    setRef,
    portalNode,
    trigger: tooltipTrigger,
    ref
  } = useTooltip({
    open,
    defaultOpen,
    withOverflowHidden,
    animate,
    parentQuerySelector,
    parentElement,
    offset,
    multiline,
    trigger,
    position,
    onClick,
    onOpen,
    onClose,
    onToggle,
    onOpened,
    onClosed,
    onToggled,
    content,
    renderContent,
    zIndex,
    noPadding,
    withMargin,
    wrapperStyle,
    customWrapper,
    width,
    height,
    disabled: disabled || !truncated,
    size,
    closeOnScroll,
    closeOnResize,
    closeOnOutsideClick,
    appearType,
    inverse,
    blurred,
    noFlip,
    excludeRef,
    closeDelay,
    portalWrapperStyle
  });
  useEffect(() => {
    if (!disabled && ref && hideTooltipOnFullText) {
      if (ref.current) {
        const isTruncated = ref.current.children[0].clientWidth < ref.current.children[0]?.scrollWidth;
        setTruncated(isTruncated);
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: setRef,
    flex: flex
  }, props), tooltipTrigger === 'enter' && /*#__PURE__*/React.createElement(OuterWrapper, {
    $offset: offset,
    $enterOffset: enterOffset
  }), children), portalNode);
};